// Shell for every wizard step: header with progress, body, footer with back/next.
// Default totalSteps matches the morning briefing; check-out passes its own.

export default function WizardCard({
  step,
  totalSteps = 7,
  title,
  subtitle,
  onBack,
  onNext,
  nextLabel = 'Next',
  nextDisabled = false,
  hideBack = false,
  hideNext = false,
  children,
}) {
  return (
    <div className="max-w-md mx-auto bg-bg-card border border-border-base rounded p-6 animate-fade-in">
      {/* Progress dots */}
      <div className="flex items-center gap-1.5 mb-4">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <span
            key={i}
            className={`h-1 flex-1 rounded ${
              i < step ? 'bg-accent-blue' : 'bg-bg-input'
            }`}
          />
        ))}
      </div>

      <h2 className="text-lg font-semibold text-text-primary">{title}</h2>
      {subtitle && (
        <p className="text-sm text-text-secondary mt-1">{subtitle}</p>
      )}

      <div className="mt-5">{children}</div>

      <div className="mt-6 flex items-center justify-between">
        {!hideBack ? (
          <button
            onClick={onBack}
            className="text-sm text-text-secondary hover:text-text-primary transition"
          >
            ← Back
          </button>
        ) : (
          <span />
        )}
        {!hideNext && (
          <button
            onClick={onNext}
            disabled={nextDisabled}
            className="px-4 py-2 bg-accent-blue text-white text-sm font-medium rounded hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed transition"
          >
            {nextLabel}
          </button>
        )}
      </div>
    </div>
  );
}
